import * as React from "react";
import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";

import { EnquiryGridSelectionContext, gridSelectionProperties } from "../../../contexts/enquiry-grid-selection.context";
import { EnquiryPropertiesContext } from "../../../contexts/enquiry-properties.context";
import { iEnquiry } from "../../../interfaces/iEnquiry";
import { getPreference } from "../../../interfaces/preference";
import { getLastTouched, saveLastTouched } from "../../../Logic/LastTouched/misc";
import { getActiveListEnquiries } from "../../../utilities/localStore/calls";
import { SortEnquiriesParams } from "../../../utilities/sort";
import EnquiryGrid from "../enquiryGrid";

import { LoadMailbox } from "../../../Logic/Enquiries/Load";
// @ts-ignore: side-effect import for CSS module without type declarations
import "./Queues.css";

function QueueLists(props: any) {
    const activeEnquiry = useSelector((state: RootState) => state.activeEnquiry);
    const [allEnquiries, setAllenquiries] = React.useState<{ enquiries: Array<iEnquiry>; totalEnquiries: number }>({
        enquiries: [],
        totalEnquiries: 0,
    });
    const enquiriesCache = useSelector((state: RootState) => state.EnquiryCache.data);
    const [sortBy, setSortBy] = React.useState<SortEnquiriesParams>();
    const { selectionProperties, SetEnquiryGridSelectionProperties } = useContext(EnquiryGridSelectionContext);
    const showEnquiryProperties = useContext(EnquiryPropertiesContext);

    useEffect(() => {
        const activeList = getActiveListEnquiries() ?? [];

        const enqCache = new Map(enquiriesCache.map(x => [x.id, x]));
        const updatedEnquiries = activeList
            .map(id => enqCache.get(id))
            .filter(x => x)
            .map(x => x!);

        const LastTouched = getLastTouched();
        const lastSort = LastTouched.Queue.EnquiryLists.find(l => l.Name == LastTouched.Queue.ActiveList)?.orderBy ?? {
            orderBy: "dateReceived",
            desc: true,
        };

        setAllenquiries({
            enquiries: updatedEnquiries,
            totalEnquiries: LastTouched.Queue.Pagination.totalItems ?? updatedEnquiries.length,
        });
        setSortBy(lastSort);

        if (selectionProperties.multiSelect) {
            const updatedEnqListIds = new Set<string>(updatedEnquiries.map(x => x.id.toString())); // did this for speed.
            const updatedList = updatedEnqListIds.intersection(new Set<string>(selectionProperties.selectedEnquiries));

            if (updatedList) {
                SetEnquiryGridSelectionProperties(currentState => {
                    return { ...currentState, selectedEnquiries: Array.from(updatedList) };
                });
            }
        }
    }, [enquiriesCache]);

    useEffect(() => {
        if (selectionProperties.multiSelect && selectionProperties.selectedEnquiries.length == 0) {
            SetEnquiryGridSelectionProperties(currentState => {
                currentState = JSON.parse(JSON.stringify(currentState));
                currentState.multiSelect = currentState.multiSelect;
                currentState.selectedEnquiries = [activeEnquiry.id.toString()];
                return currentState;
            });
        }
    }, [selectionProperties.multiSelect]);

    const handleHeaderClick = async (fieldName: string): Promise<any> => {
        let updatedEnquires = [...allEnquiries.enquiries];
        const lastTouched = getLastTouched();
        const activeList = lastTouched.Queue.EnquiryLists.find(l => l.Name == lastTouched.Queue.ActiveList)!;

        if (lastTouched.Queue.Pagination.sortColumn !== fieldName) {
            lastTouched.Queue.Pagination.sortColumn = fieldName;
            lastTouched.Queue.Pagination.sortAscending = true;
        } else {
            lastTouched.Queue.Pagination.sortAscending = !lastTouched.Queue.Pagination.sortAscending;
        }
        lastTouched.Queue.Pagination.pageNumber = 1;
        activeList.orderBy ??= { orderBy: null };

        if (activeList.orderBy.orderBy == fieldName) {
            activeList.orderBy = {
                orderBy: fieldName,
                desc: !activeList.orderBy.desc,
            };
        } else {
            activeList.orderBy = {
                orderBy: fieldName,
            };
        }
        saveLastTouched(lastTouched);
        const response = await LoadMailbox(lastTouched.Queue.ActiveList);
        /*const order = activeList.orderBy;
        if (order.orderBy) {
            if (order.orderBy == "owners") {
                updatedEnquires = sortOwner(updatedEnquires, order.desc);
            } else if (order.orderBy == "status") {
                updatedEnquires = sortStatus(updatedEnquires, order.desc);
            } else {
                updatedEnquires = sortByField(updatedEnquires, order.orderBy, order.desc);
            }
        }
        if (!response.isOk || !response.data) {
            throw new Error("Failed to retrieve enquiries.");
        }
        lastTouched.Queue.Pagination.totalItems = response.data.totalEnquiries;

        saveActiveListEnquiries(response.data.enquiries.map(x => x.id));
        setAllenquiries(response.data.enquiries);
        setSortBy(activeList.orderBy);*/
    };

    const multiSelectOnclick = (selectionProperties: gridSelectionProperties) => {
        SetEnquiryGridSelectionProperties(currentState => {
            currentState = JSON.parse(JSON.stringify(currentState));
            currentState.multiSelect = selectionProperties.multiSelect;
            currentState.selectedEnquiries = selectionProperties.selectedEnquiries;
            return currentState;
        });
    };

    return (
        <>
            {allEnquiries.enquiries.length > 0 && (
                <EnquiryGrid
                    data={allEnquiries.enquiries}
                    theme="dataTable_default"
                    sortFunction={handleHeaderClick}
                    sortCol={sortBy}
                    selectedEnquiry={activeEnquiry.id}
                    columns={getPreference().grids.mailbox}
                    multiSelect={selectionProperties.multiSelect}
                    selectedItems={selectionProperties.selectedEnquiries}
                    updateSelectedItems={multiSelectOnclick}
                    dataTableId="mailbox"
                    usesPagination={true}
                    totalItems={allEnquiries.totalEnquiries}
                    onRowDblClick={enquiryId => showEnquiryProperties(enquiryId)}
                    changePage={() => {
                        const lastTouched = getLastTouched();
                        LoadMailbox(lastTouched.Queue.ActiveList);
                    }}
                ></EnquiryGrid>
            )}
            {allEnquiries.enquiries.length == 0 && (
                <div style={{ padding: "12px", fontSize: "9pt" }}>No enquiries found</div>
            )}
        </>
    );
}

export default QueueLists;
